//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.8.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum ActivityLogObject {
    User = 0,
    Form = 10,
}

export enum ActionType {
    Undefined = 0,
    FormChanged = 1,
    FormDeleted = 2,
    UserUpdated = 100,
    UserDeleted = 101,
    HttpRepFormChanged = 200,
}

export interface ActivityLogsModel {
    id: string;
    timestamp: Date;
    userId: string;
    affectedObject: ActivityLogObject;
    affectedObjectId: string;
    action: ActionType;
    requestPath: string | undefined;
    data: string[] | undefined;
}